"use client"
import { Col, Image, Row } from 'antd';
import React, { useState } from 'react'
import Lightbox from 'yet-another-react-lightbox';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import Download from 'yet-another-react-lightbox/plugins/download';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Video from 'yet-another-react-lightbox/plugins/video';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "./style.css";

const GalleryWithCoverPhotos = ({ images }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    return (
        <div className='image-previewer-container'>
            <Row gutter={10}>
                <Col
                    xxl={images.length == 1 ? 24 : 18}
                    xl={images.length == 1 ? 24 : 18}
                    lg={images.length == 1 ? 24 : 18}
                    md={images.length == 1 ? 24 : 18}
                    sm={images.length == 1 ? 24 : 18}
                    xs={images.length == 1 ? 24 : 18}
                    className='package-cover-image'
                >
                    <Image
                        src={images[0].original}
                        alt="Main view"
                        style={styles.mainImage}
                        onClick={() => {
                            setCurrentIndex(0);
                            setIsPreviewOpen(true);
                        }}
                        preview={false}
                    />
                </Col>
                {images.length > 1 && (
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} style={styles.thumbnailContainer}>
                        {images.slice(1, 4).map((img, index) => {
                            return (
                                <div key={index} style={styles.thumbnailWrapper}>
                                    <Image
                                        src={img.thumbnail}
                                        style={{ ...styles.thumbnail, height: "100%" }}
                                        onClick={() => {
                                            setCurrentIndex(index + 1);
                                            setIsPreviewOpen(true);
                                        }}
                                        preview={false}
                                    />
                                    {index === 2 && images.length > 4 && (
                                        <button
                                            onClick={() => {
                                                setCurrentIndex(index + 1)
                                                setIsPreviewOpen(true);
                                            }}
                                            style={styles.seeMoreButton}
                                        >
                                            +{images.length - 4} more
                                        </button>
                                    )}
                                </div>
                            )
                        })}
                    </Col>
                )}
            </Row>
            <Lightbox
                open={isPreviewOpen}
                index={currentIndex}
                close={() => setIsPreviewOpen(false)}
                slides={images.map((img) =>
                    img.type.includes("video") ?
                        ({ type: "video", sources: [{ src: img.original, type: "video/mp4" }] }) :
                        ({ src: img.original, type: img.type })
                )}
                plugins={[Download, Counter, Fullscreen, Thumbnails, Zoom, Video]}
                video={{ autoPlay: true, playsInline: true, preload: "auto", muted: true }}
                counter={{ container: { style: { top: "unset", bottom: 0, left: "50%" } } }}
                controller={{ closeOnBackdropClick: true, closeOnPullUp: true }}
            />
        </div>
    )
}

export default GalleryWithCoverPhotos

const styles: any = {
    mainImage: {
        width: '100%',
        aspectRatio: '16/9',
        objectFit: 'cover',
        cursor: 'pointer',
        height: "100%",
        borderRadius: "8px"
    },
    thumbnailContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: "10px",
        height: "auto"
    },
    thumbnailWrapper: {
        position: 'relative',
        flex: '1 1 0',
        overflow: 'hidden',
        borderRadius: 8
    },
    thumbnail: {
        width: '100%',
        objectFit: 'cover',
        cursor: 'pointer',
        aspectRatio: "16 / 9"
    },
    seeMoreButton: {
        position: 'absolute',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.6)',
        color: 'white',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '20px',
        borderRadius: '8px'
    },
}